export default __webpack_public_path__ + "static/media/pagination_left_arrow.7c42b989.svg";